import React from 'react';

const PartialTextWithIcon = ({ block }) => {
  let hasText = false;

  block.items.map(item => {
    if (item.text) {
      hasText = true;
    }
  });

  return (
    <section
      className={`partial ${block._template} ${hasText ? 'has-text' : ''}`}
    >
      {block.items.map((item, index) => (
        <div
          key={index}
          className='item'
        >
          {item.icon && (
            <img
              src={item.icon}
              alt={item.title}
              title={item.title}
              loading='lazy'
            />
          )}
          <div
            className='content-wr'
            style={{ padding: 0 }}
          >
            {item.title && (
              <h4 dangerouslySetInnerHTML={{ __html: item.title }}></h4>
            )}
            {item.text && (
              <div
                className='text-formatted'
                dangerouslySetInnerHTML={{ __html: item.text }}
              ></div>
            )}
          </div>
        </div>
      ))}
    </section>
  );
};

export default PartialTextWithIcon;
